import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { validations, RadioField, SimpleSelectField } from '@unite-us/app-components';
import getOutcomesOptions from 'src/common/utils/Outcomes/utils/getOutcomesOptions';

const OutcomeField = ({
  outcomeLabel,
  outcomes,
  resolvedValue,
  useRadioOutcomes,
}) => {
  const options = getOutcomesOptions(outcomes, resolvedValue);

  if (useRadioOutcomes) {
    return (
      <Field name="outcome_id">
        {(params) => (
          <RadioField
            id="outcomeInput"
            label={outcomeLabel}
            labelClassName="uppercase mb-2"
            options={options}
            required
            {...params}
            validations={validations.isRequired}
          />
        )}
      </Field>
    );
  }

  return (
    <Field name="outcome_id">
      {({ input, meta }) => (
        <SimpleSelectField
          id="outcomeInput"
          label={outcomeLabel}
          options={options}
          value={input.value}
          onChange={input.onChange}
          onBlur={input.onBlur}
          required
          error={meta.touched && meta.error ? meta.error : undefined}
        />
      )}
    </Field>
  );
};

OutcomeField.propTypes = {
  outcomeLabel: PropTypes.string.isRequired,
  outcomes: PropTypes.array.isRequired,
  resolvedValue: PropTypes.string,
  useRadioOutcomes: PropTypes.bool.isRequired,
};

OutcomeField.defaultProps = {
  resolvedValue: undefined,
};

export default OutcomeField;
